// 興味関心チェックの定数.
export const CIRCLE: string = '○';
export const OTHER: string = 'その他';

// 各項目のタイトル.
export const TOILET: string = '自分でトイレへ行く';
export const LIFELONG_LEARNING: string = '生涯学習・歴史';
export const BATHING: string = '一人でお風呂に入る';
export const READING: string = '読書';
export const WEARING: string = '自分で服を着る';
export const HAIKU: string = '俳句';
export const EATING: string = '自分で食べる';
export const SHODO: string = '書道・習字';
export const BRUSHING: string = '歯磨きをする';
export const PAINTING: string = '絵を描く・絵手紙';
export const GROOMING: string = '身だしなみを整える';
export const TYPING: string = 'パソコン・ワープロ';
export const SLEEPING: string = '好きなときに眠る';
export const PHOTO: string = '写真';
export const CLEANING: string = '掃除・整理整頓';
export const THEATER: string = '映画・観劇・演奏会';
export const COOKING: string = '料理を作る';
export const SADO_KADO: string = 'お茶・お花';
export const SHOPPING: string = '買い物';
export const SINGING: string = '歌を歌う・カラオケ';
export const GARDENING: string = '家の庭の手入れ・世話';
export const MUSIC: string = '音楽を聴く・楽器演奏';
export const LAUNDERING: string = '洗濯・洗濯物たたみ';
export const GAMING: string = '将棋・囲碁・麻雀・ゲーム等';
export const DRIVING: string = '自転車・車の運転';
export const EXERCISING: string = '体操・運動';
export const OUTING: string = '電車・バスでの外出';
export const STROLLING: string = '散歩';
export const CHILDREN: string = '孫・子供の世話';
export const PLAYING_SPORTS1: string = 'ゴルフ・グラウンドゴルフ・';
export const PLAYING_SPORTS2: string = '水泳・テニスなどのスポーツ';
export const ANIMAL: string = '動物の世話';
export const DANCING: string = 'ダンス・踊り';
export const FRIENDS: string = '友達とおしゃべり・遊ぶ';
export const WATCHING_SPORTS: string = '野球・相撲等観戦';
export const FAMILY: string = '家族・親戚との団らん';
export const GAMBLING: string = '競馬・競輪・競艇・パチンコ';
export const DATING: string = 'デート・異性との交流';
export const KNITTING: string = '編み物';
export const DRINKING: string = '居酒屋に行く';
export const SEWING: string = '針仕事';
export const VOLUNTEER: string = 'ボランティア';
export const CROPPING: string = '畑仕事';
export const COMMUNITY_ACTIVITY: string = '地域活動(町内会・老人クラブ)';
export const EARNING: string = '賃金を伴う仕事';
export const RELIGION: string = 'お参り・宗教活動';
export const TRAVELING: string = '旅行・温泉';

// multiple(連想配列型).
export interface Multiple {
  other1: {
    column: string;
    check: Check;
  };
  other2: {
    column: string;
    check: Check;
  }; 
  other3: {
    column: string;
    check: Check;
  };
  other4: {
    column: string;
    check: Check;
  };
}

// チェック.
export interface Check {
  // している.
  do: boolean;
  // してみたい.
  interested: boolean;
  // 興味がある.
  want: boolean;
}

// 返り値の型.
export interface ResponseData {
  // Unique ID
  unique_id: string;
  // 自分でトイレに行く.
  toilet: Check;
  // 一人でお風呂に入る.
  bathing: Check;
  // 自分で服を着る.
  wearing: Check;
  // 自分で食べる.
  eating: Check;
  // 歯磨きをする.
  brushing: Check;
  // 身だしなみを整える.
  grooming: Check;
  // 好きな時に眠る.
  sleeping: Check;
  // 掃除・整理整頓.
  cleaning: Check;
  // 料理を作る.
  cooking: Check;
  // 買い物.
  shopping: Check;
  // 家の庭の手入れ・世話.
  gardening: Check;
  // 洗濯・洗濯物たたみ.
  laundering: Check;
  // 自転車・車の運転.
  driving: Check;
  // 電車・バスでの外出.
  outing: Check;
  // 孫・子供の世話.
  children: Check;
  // 動物の世話.
  animal: Check;
  // 友達とおしゃべり・遊ぶ.
  friends: Check;
  // 家族・親戚との団欒.
  family: Check;
  // デート・異性との交流.
  dating: Check;
  // 居酒屋に行く.
  drinking: Check;
  // ボランティア.
  volunteer: Check;
  // 地域活動（町内会・老人クラブ）.
  community_activity: Check;
  // お参り・宗教活動.
  religion: Check;
  // 生涯学習・歴史;
  lifelong_learning: Check;
  // 読書.
  reading: Check;
  // 俳句.
  haiku: Check;
  // 書道・習字.
  shodo: Check;
  // 絵を描く・絵手紙.
  painting: Check;
  // パソコン・ワープロ.
  typing: Check;
  // 写真.
  photo: Check;
  // 映画・観劇・演奏会.
  theater: Check;
  // お茶・お花.
  sado_kado: Check;
  // 歌を歌う・カラオケ.
  singing: Check;
  // 音楽を聴く・楽器演奏.
  music: Check;
  // 将棋・囲碁・麻雀・ゲーム等.
  gaming: Check;
  // 体操・運動.
  exercising: Check;
  // 散歩.
  strolling: Check;
  // ゴルフ・グランドゴルフ・水泳・テニスなどのスポーツ.
  playing_sports: Check;
  // ダンス・踊り.
  dancing: Check;
  // 野球・相撲観戦.
  watching_sports: Check;
  // 競馬・競輪・協定・パチンコ.
  gambling: Check;
  // 編み物.
  knitting: Check;
  // 針仕事.
  sewing: Check;
  // 畑仕事.
  cropping: Check;
  // 賃金を伴う仕事.
  earning: Check;
  // 旅行・温泉.
  traveling: Check;
  // その他.
  additional_item: Multiple;
  // 聞き取り日(yyy-mm-dd)
  visited_day: string;
  // データ作成時間.
  // yyyy-mm-dd hh:mm:ss
  created_at: string;
  // データ更新時間.
  updated_at: string;
}

export const LOADING: string = 'INTEREST_CHECK_LOADING';
// エラーでもFINISH
export const FINISH: string = 'INTEREST_CHECK_FINISH';


// WEBPACK FOOTER //
// ./src/constants/InterestCheck.tsx